import { Separator } from "@/components/ui/separator";

export function SeparadorOu({ texto = "ou com e-mail" }: { texto?: string }) {
  return (
    <div className="my-5 flex items-center gap-3">
      <Separator className="flex-1" />
      <span className="text-[11px] font-medium tracking-wider text-muted-foreground uppercase">{texto}</span>
      <Separator className="flex-1" />
    </div>
  );
}
